import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { useStickyState } from '../libs/hooksLib';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm';

function Notification({
  id = 0,
  type = 'info',
  message = '',
  dismissible = true,
  ...props
}) {
  const [hidden, setHidden] = useStickyState(false, `hide-notification-${id}`);

  return(
    <>
      {
        hidden ? null :
        <Alert
          variant = { type }
          key = { id }
          onClose={ () => setHidden(true) }
          dismissible = { dismissible }
        >
          <ReactMarkdown remarkPlugins={[gfm]}>
            { message }
          </ReactMarkdown>
        </Alert>
      }
    </>
  );
}

Notification.propTypes = {
  /**
   * Notification id.
   */
  id: PropTypes.number,
  /**
   * Type of notification, determines how the notification is displayed. One of:
   * 
   * * primary
   * * secondary
   * * success
   * * danger
   * * warning
   * * info
   * * light
   * * dark
   * 
   * Corresponds with types from bootstrap.
   */
   type: PropTypes.string,
   /**
    * Markdown message to display.
    */
   message: PropTypes.string,
   /**
    * Whether the message can be dismissed.
    */
  dismissible: PropTypes.bool,
 }

export default Notification;